import React from 'react';
import { Box, TextField, IconButton, Tooltip } from '@mui/material';
import {
  WorkOutline as WorkOutlineIcon,
  HourglassEmpty as HourglassEmptyIcon,
} from '@mui/icons-material';
import { FULL_DAY_HOURS, HALF_DAY_HOURS } from '../config/timeConstants';

const HoursInput = ({ value, onChange, size = 'medium', fullWidth = false }) => {
  const handleHoursChange = (hours) => {
    const currentMinutes = Math.round((value - Math.trunc(value)) * 60);
    const newValue = parseFloat(hours) + (currentMinutes / 60);
    onChange(newValue);
  };

  const handleMinutesChange = (minutes) => {
    const currentHours = Math.trunc(value);
    const newValue = parseFloat(currentHours) + (minutes / 60);
    onChange(newValue);
  };

  const handleShortcut = (type) => {
    switch (type) {
      case 'fullDay':
        onChange(FULL_DAY_HOURS);
        break;
      case 'halfDay':
        onChange(HALF_DAY_HOURS);
        break;
      default:
        break;
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        label="H"
        type="number"
        value={Math.trunc(value) || '0'}
        onChange={(e) => handleHoursChange(e.target.value)}
        size={size}
        InputProps={{
          inputProps: { min: 0, max: 23, step: 1 }
        }}
        sx={{ width: fullWidth ? '40%' : 'auto' }}
      />
      <TextField
        label="Min"
        type="number"
        value={Math.round((value - Math.trunc(value)) * 60) || '0'}
        onChange={(e) => handleMinutesChange(parseInt(e.target.value))}
        size={size}
        InputProps={{
          inputProps: { min: 0, max: 59, step: 1 }
        }}
        sx={{ width: fullWidth ? '40%' : 'auto' }}
      />
      <Tooltip title="1/2 Journée">
        <IconButton size={size} onClick={() => handleShortcut('halfDay')}>
          <HourglassEmptyIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Journée">
        <IconButton size={size} onClick={() => handleShortcut('fullDay')}>
          <WorkOutlineIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default HoursInput;
